import {
  TAG_MANAGER_URL,
  HEAD_DEPLOY_SELECTOR_ID,
  BODY_DEPLOY_SELECTOR_ID,
  GLOBAL_LIB_VAR
} from './constants';

const
  headScript = document.createElement('script'),
  bodyScript = document.createElement('script'),
  currentScript = document.currentScript || (function() {
    const scripts = document.getElementsByTagName('script');
    return scripts[scripts.length - 1];
  }())
;

var propertyId = currentScript.getAttribute('data-property-id') || '';

headScript.id = HEAD_DEPLOY_SELECTOR_ID;
headScript.src = TAG_MANAGER_URL.replace(/{{property-id}}/, propertyId);

bodyScript.id = BODY_DEPLOY_SELECTOR_ID;
bodyScript.innerHTML = `${GLOBAL_LIB_VAR}.pageBottom();`;

export {headScript, bodyScript, propertyId};



// WEBPACK FOOTER //
// ./src/deploys.js